import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import Icon from 'Components/Atoms/Icon/Icon';
import { cn } from 'Utils/cn';

const SelectWithoutBorder = forwardRef(function SelectWithoutBorder({ options, className, ...other }, ref) {
    return (
        <div className={cn('relative inline-flex items-center', className)}>
            <select
                ref={ref}
                className="cursor-pointer appearance-none border-0 bg-transparent py-1 pl-1 pr-10 text-xl font-semibold text-dark-blue outline-none focus:outline-none"
                {...other}
            >
                {options.map((item) => (
                    <option key={item.id} value={item.id}>
                        {item.label}
                    </option>
                ))}
            </select>
            <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
                <Icon name="chevron-down" color="currentColor" size={24} />
            </span>
        </div>
    );
});

SelectWithoutBorder.displayName = 'SelectWithoutBorder';

SelectWithoutBorder.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
};

export default SelectWithoutBorder;
